var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuItemVoucherInquiry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 1.417v2.166-2.166zm0 6.5v2.166-2.166zm0 6.5v2.166-2.166zm-10.833-13A2.167 2.167 0 001.25 3.583v3.25a2.167 2.167 0 110 4.334v3.25a2.167 2.167 0 002.167 2.166h15.166a2.167 2.167 0 002.167-2.166v-3.25a2.167 2.167 0 010-4.334v-3.25a2.167 2.167 0 00-2.167-2.166H3.417z",
    stroke: "#ED1B2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgIconMenuItemVoucherInquiry;